<template>
  <button @click="handleJoin">{{ eventLabel }}</button>
</template>

<script setup>
import {computed} from "vue";
import {useRouter} from "vue-router";
import useOnlineSessions from "@/composables/useOnlineSessions";
import useJoinLink from "@/composables/useJoinLink";
import useUserSafe from "@/composables/useUserSafe";
import history from "@/assets/history.json";

const router = useRouter();
const {activeSession} = useOnlineSessions();
const {getJoinLink} = useJoinLink(history.latestYear);
const {isSignedIn} = useUserSafe();

const EVENT_LABELS = {
  masterclass: "Join Masterclass Now",
  workshop: "Join Workshop Now",
  showcase: "Join Showcase Now"
};

const eventLabel = computed(() => EVENT_LABELS[activeSession.value?.eventKey] || "Join Event Now");

const joinLink = computed(() => {
  if (!activeSession.value) return null;
  return getJoinLink(activeSession.value.eventKey);
});

function handleJoin() {
  if (!isSignedIn.value) {
    router.push({hash: "#join"});
    return;
  }
  if (joinLink.value) window.location.href = joinLink.value;
}
</script>

<style scoped>
button {
  display: inline-flex;
  gap: 0.4em;
  align-items: baseline;
  color: white;
  background-color: var(--brand-color);
  padding: 0.6rem 2.3rem;
  border: none;
  border-radius: 17px;
  cursor: pointer;
  white-space: nowrap;
  font-weight: bold;
}
button:hover { background-color: var(--brand-hover-color); }
</style>
